<!-- Pending changes are only shown to the submitter and approvers -->
<div class="home-pending-change small" [ngClass]="{ 'pending-delete': isDelete }" *ngIf="pendingChange && (canApprove || isSubmitter)">
  <!-- Title and actions share one row to keep the Home cards compact -->
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center">
      <mat-icon class="mr-1" [color]="isDelete ? 'warn' : 'primary'">{{
        isDelete ? "auto_delete" : "pending_actions"
      }}</mat-icon>
      <span class="bold" [ngClass]="isDelete ? 'red' : 'blue'">{{ title }}</span>
    </div>
    <div class="d-flex align-items-center pending-actions">
      <button
        mat-icon-button
        matTooltip="Approve"
        aria-label="Approve"
        *ngIf="canApprove"
        [disabled]="busy"
        (click)="approve()"
      >
        <mat-icon class="green">check_circle</mat-icon>
      </button>
      <button
        mat-icon-button
        matTooltip="Disapprove"
        aria-label="Disapprove"
        *ngIf="canApprove"
        [disabled]="busy"
        (click)="disapprove()"
      >
        <mat-icon class="red">cancel</mat-icon>
      </button>
      <button
        mat-icon-button
        matTooltip="Cancel pending change"
        aria-label="Cancel pending change"
        *ngIf="isSubmitter"
        [disabled]="busy"
        (click)="cancel()"
      >
        <mat-icon class="red">undo</mat-icon>
      </button>
    </div>
  </div>
  <!-- Same size and date style as the card footer -->
  <div class="pending-submitted gray">
    Submitted by <b>{{ pendingChange.createdByUser }}</b> on
    <span class="date">{{ pendingChange.createdOn | date : "yyyy-MM-dd h:mm a" }}</span>
  </div>
  <div *ngFor="let field of changes">
    Proposed {{ field.label }}: <b>{{ field.value }}</b>
    <!-- Attachment changes link to the images so approvers can review them -->
    <ng-container *ngFor="let file of field.files; let last = last">
      <a *ngIf="file.url; else fileName" [href]="file.rootDirectory | fileLink" target="_blank">{{ file.fileName }}</a>
      <ng-template #fileName>{{ file.fileName }}</ng-template>{{ last ? "" : ", " }}
    </ng-container>
  </div>
</div>
